
import { Component, Mixins, Emit } from "vue-property-decorator";
import { ModelEditableMixin } from "../../mixins";

@Component
export default class DateSelectableMixin extends Mixins(ModelEditableMixin) {
  @Emit()
  dateUpdated(): void {}

  data(): any {
    return {
      isJapaneseCalendarEditable: false,
    };
  }
  isJapaneseCalendarEditable: boolean;

  now(): Date {
    return new Date();
  }

  today(): Date {
    return new Date(
      this.now().getFullYear(),
      this.now().getMonth(),
      this.now().getDate()
    );
  }

  firstDayOfThisMonth(): Date {
    return new Date(
      this.today().getFullYear(),
      this.today().getMonth(),
      1
    );
  }

  lastDayOfThisMonth(): Date {
    return new Date(
      this.today().getFullYear(),
      this.today().getMonth() + 1,
      0
    );
  }

  firstDayOfThisYear(): Date {
    return new Date(
      this.today().getFullYear(),
      0,
      1
    );
  }

  lastDayOfThisYear(): Date {
    return new Date(
      this.today().getFullYear() + 1,
      0,
      0
    );
  }

  activateJapaneseCalendar(): void {
    this.isJapaneseCalendarEditable = true;
  }

  disactivateJapaneseCalendar(): void {
    this.isJapaneseCalendarEditable = false;
  }

  onDateEditorYearFocused() {
    // Tabキーでのフォーカス移動対策
    // isJapaneseCalendarEditableは和暦/西暦の有効/無効の判断に使用(DateEditableMixin)
    // isJapaneseCalendarEditableは和暦/西暦の@pointerdownで切り替えている
    // 和暦から西暦へTabキーで移動した場合も切り替えが必要
    this.disactivateJapaneseCalendar();
  }

  applyValue(value: Date | string) {
    this.editingSource = value;
    this.dateUpdated();
  }
}
